import React from 'react';
import { HomeBanner } from '../../components/home/homeBanner';
import { BeingPart } from './beignpart';
// import { CategoryAuctions } from './categoryAuctions';
// import { CategorySearch } from './helpers/categorySearch';
import { CategoryAuctionsNew } from './components/CatergoryAuctions';

export class Homepage extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <HomeBanner callbackForSupport={this.props.callbackForSupport} />
        {/* <CategorySearch /> */}
        {/* <CategoryAuctions /> */}
        <CategoryAuctionsNew />
        <BeingPart />
      </div>
    );
  }
}
